import React, { useState, useEffect, useRef } from 'react';

interface Transaction {
  amount: number;
  date: string;
  description: string;
  [key: string]: any;
}

const App: React.FC = () => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [filter, setFilter] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const listRef = useRef<HTMLDivElement>(null);

  const fetchData = async (endpoint: string) => {
    setIsLoading(true);
    try {
      const response = await fetch(`https://api-quachtinh.lehongthai.vip/banks/${endpoint}`);
      const data = await response.json();
      setTransactions(data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value.toLowerCase());
  };

  const filteredTransactions = transactions.filter(transaction => 
    Object.values(transaction).some(value => 
      value !== null && 
      value !== undefined && 
      value.toString().toLowerCase().includes(filter)
    )
  );

  const scrollToTop = () => {
    listRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1, maximum-scale=1';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
        <button onClick={() => fetchData('acb-hang')} style={styles.button}>ACB H</button>
        <button onClick={() => fetchData('acb-thai')} style={styles.button}>ACB T</button>
      </div>
      <div style={styles.filterContainer}>
        <input
          type="text"
          placeholder="Filter"
          onChange={handleFilter}
          style={styles.input}
        />
        <button style={styles.filterButton}>Filter</button>
      </div>
      <h2 style={styles.heading}>Danh sách giao dịch</h2>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div ref={listRef} style={styles.transactionList}>
          {filteredTransactions.map((transaction, index) => (
            <div key={index} style={styles.transaction}>
              <span style={{ ...styles.amount, color: transaction.amount < 0 ? 'red' : 'green' }}>
                {transaction.amount.toLocaleString()}
              </span>
              <span style={styles.date}>{transaction.time}</span>
              <p style={styles.description}>{transaction.description}</p>
            </div>
          ))}
        </div>
      )}
      <button onClick={scrollToTop} style={styles.upButton}>UP</button>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    maxWidth: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#1e1e1e',
    color: 'white',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#8a2be2',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  filterContainer: {
    display: 'flex',
    marginBottom: '10px',
  },
  input: {
    flex: 1,
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px 0 0 5px',
    border: '1px solid #ccc',
    backgroundColor: '#333',
    color: 'white',
  },
  filterButton: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#8a2be2',
    color: 'white',
    border: 'none',
    borderRadius: '0 5px 5px 0',
    cursor: 'pointer',
  },
  heading: {
    fontSize: '18px',
    marginBottom: '10px',
  },
  transactionList: {
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
  },
  transaction: {
    backgroundColor: '#333',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '5px',
  },
  amount: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
  date: {
    float: 'right',
    color: '#999',
  },
  description: {
    margin: '5px 0 0',
    fontSize: '14px',
  },
  upButton: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: '#8a2be2',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default App;
